export const parseError = (error: any) => {
  if (!error) return "";
  const message = typeof error === "string" ? error : error.message;
  return message.replace(/Network error: |GraphQL error: |Node error: /g, "");
};
